import React, {useState, useEffect} from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import Button from "olive-react-myoneui/lib/Button";
import { useNavigate } from 'react-router-dom';
import BreadCrumbs from '../BreadCrumbs';
import { calendarsIcon, clockIcon, linkIcon, homeIcon, geoMarkIcon, leftArrowLong, facebookLogoIcon, linkedInIcon, twitterXIcon, shareOIcon } from "../../../constants/icons";
import CoursePlay from '../courses/CoursePlay';
import EventSessions from './EventSessions';
import { getEventContents } from '../../../../api/afterLogin/events';
import { MyEventCalendar } from 'mykademy-learner-student-dashboard';
import { encode } from 'js-base64';
import { format, parseISO } from "date-fns";
import { EventContentLoader, EventThumbnailLoader } from '../../Loader';
import { imageSrc, filterUrl } from '../../../../helpers/url_helper';
import { sanitizeSlug } from '../../../../helpers/string_helper';
import Error404 from '../../../../modules/Error404';
import Error403 from '../../../../modules/Error403';
import { checkDisabledSp } from '../../../../helpers/permission_helper';
import { getSPAuthTokens } from '../../../../helpers/spauth_token_helper';
import { decryptData } from '../../../../helpers/crypto_helper';

const EventDetails = ({ className }) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const adminData = useSelector((state) => state.admin);
  const configData = useSelector((state) => state.config);
  const paths = useSelector((state) => state.user.paths);
  const learnerId   = configData?.session?.id ?? 0;
  const [eventContent, setEventContent] = useState([]);
  const [eventActivityContent, setEventActivityContent] = useState([]);
  const [eventPresenters, setEventPresenters] = useState([]);
  const [showEmptyItemBlock, setShowEmptyItemBlock] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [eventAuthToken, setEventAuthToken] = useState(null);
  const { slug } = useParams();
  const navigate = useNavigate();

  // CALENDER
  let origin      = window.location.pathname;
  const myArray   = origin.split("/");
  const spuid     = (myArray[1] == "student-dashboard") ? "mykademy" : myArray[1];
  const idp       = configData.idp;
  const secret    = decryptData(adminData.secret);
  const accountId = adminData.account_id;
  const timezone  = adminData.us_timezone;
  const uuid      = adminData.us_uid;
  const language  = adminData.language;
  const defaultImg= paths?.default_event;

  /* ACCESS CHECK */
  const products  = adminData.products;
  const userSpEnabled = adminData?.user_sp_enabled;
  const [noAccess, setNoAccess] = useState(checkDisabledSp('tms', products, userSpEnabled));

  const fetchContents = async (params) => {
    if (params.slug == '') {
      setHasError(true);
      return;
    }
    try {
      const fetchEventContent = await getEventContents(configData.access_token, params);
      setIsLoading(false);
      return fetchEventContent;
    } catch (error) {
      setIsLoading(false);
      setHasError(true);
      console.error(error);
    }
  };

  useEffect(() => {
    setShowEmptyItemBlock(false);
    const loadData = async () => {
      try {
        const data = await fetchContents({slug: sanitizeSlug(slug)});
        if (data.status === 200 && data.data) {
          setEventContent(data.data);
          setEventActivityContent(data.data.event_activities.filter((activity) => activity.ea_activity_type === 'session' || activity.ea_activity_type === 'Course' || activity.ea_activity_type === 'Bundle'));
          setEventPresenters(data.data.presenters);
          setShowEmptyItemBlock(true);
        } else {
          setHasError(true);
        }
      } catch (error) {
        setHasError(true);
        console.error(error);
      }
    }
    if (learnerId) {
      const fetchTokenData = async () => {
        const tokenData = await getSPAuthTokens('mykademy', configData.access_token);
        if (tokenData) {
          setEventAuthToken(tokenData);
          loadData();
        } else {
          loadData();
        }
      };
      fetchTokenData();
    }
    
    
  }, [slug]);

  const eventPages = [
    { icon: homeIcon, label: "Home", url: "/student-dashboard/" },
    { icon: calendarsIcon, label: "Events", url: "/student-dashboard/events" },
    { label: (eventContent?.bce_name !== undefined && eventContent?.bce_name !== null) ? eventContent?.bce_name : 'Event' }
  ];

  const toggleDescription = () => {
    setIsExpanded(!isExpanded);
  };

  const startEndDate = (eventContent?.bce_start_date ? format(parseISO(eventContent?.bce_start_date.split("T")[0]+'T'+eventContent?.bce_start_time+'Z'), "MMM d, yyyy") : '') 
                            + ' - ' + 
                           (eventContent?.bce_end_date ? format(parseISO(eventContent?.bce_end_date.split("T")[0]+'T'+eventContent?.bce_end_time+'Z'), "MMM d, yyyy") : '')
  
  const startEndTime = (eventContent?.bce_start_date ? format(parseISO(eventContent?.bce_start_date.split("T")[0]+'T'+eventContent?.bce_start_time+'Z'), "h:mm a") : '') 
                            + ' - ' + 
                           (eventContent?.bce_end_date ? format(parseISO(eventContent?.bce_end_date.split("T")[0]+'T'+eventContent?.bce_end_time+'Z'), "h:mm a") : '')
  
  const sessionDate = (eventContent?.bce_start_date ? format(parseISO(eventContent?.bce_start_date.split("T")[0]+'T'+eventContent?.bce_start_time+'Z'), "yyyy-MM-d") : '') 
                      + ' - ' + 
                      (eventContent?.bce_end_date ? format(parseISO(eventContent?.bce_end_date.split("T")[0]+'T'+eventContent?.bce_end_time+'Z'), "yyyy-MM-d") : '')

  const endDate = eventContent?.bce_end_date ? parseISO(eventContent.bce_end_date.split("T")[0]+'T'+eventContent?.bce_end_time+'Z') : '';
  const isSessionExpired = new Date() > new Date(endDate) ? 1 : 0

  const startDateForSession = eventContent?.bce_start_date ? eventContent?.bce_start_date.split("T")[0]+'T'+eventContent?.bce_start_time+'Z' : '';
  const endDateForSession   = eventContent?.bce_end_date ? eventContent?.bce_end_date.split("T")[0]+'T'+eventContent?.bce_end_time+'Z' : '';
  
  const eventData = {
    imageDetails: {
      src: imageSrc('event', eventContent?.bce_thumbnail, paths),
      title: eventContent?.bce_name ?? 'Event',
    },
    webinarDetails: {
      title: eventContent?.bce_name ?? '',
      description: eventContent?.bce_description ?? '',
      backIcon: leftArrowLong,
      venue: eventContent?.bce_delivered_type === 'live' ? 'online' : eventContent?.bce_delivered_type !== '' ? eventContent?.bce_venue + ', ' + eventContent?.bce_venue_location : ''
    },
    instructorDetails: eventPresenters && eventPresenters?.map((presenter) => ({
      name: presenter?.us_name ?? '',
      email: presenter?.us_email ?? '',
      image: presenter?.us_image ? imageSrc('user', presenter.us_image, paths) : ''
    })),
    summary: eventContent?.bce_summary ?? '',
    courseInfo: [
      { icon: calendarsIcon, text: startEndDate},
      { icon: clockIcon, text: startEndTime },
      { icon: geoMarkIcon, text: eventContent?.bce_delivered_type === 'live' ? 'Online' : eventContent?.bce_delivered_type !== '' ? eventContent?.bce_venue + ', ' + eventContent?.bce_venue_location : '' }
    ]
  };

  
  const handleBackClick = () => {
    navigate('/events');
  };

  const isExternalLink = (url) => {
    try {
        const linkUrl = new URL(url);
        return linkUrl.protocol === "http:" || linkUrl.protocol === "https:";
    } catch (e) {
        return false;
    }
  };

  const handleJoinEventClick = () => {
    const link = eventContent.bce_delivered_type === 'live' && 
                eventContent.event_activities && 
                eventContent.event_activities.length > 0 ? eventContent.event_activities[0].live_classes.lc_session_link : '';
    if (link) {
      if (isExternalLink(link)) {
          window.open(link, "_blank");
      } else {
          navigate(link);
      }
    }
  };
  
  const maxChars = 500;
  const displayDesc = isExpanded
    ? eventData.webinarDetails.description
    : eventData.webinarDetails.description && eventData.webinarDetails.description.length > maxChars ? 
      `${eventData.webinarDetails.description.substring(0, maxChars)}...` : 
      eventData.webinarDetails.description === '' ? 'N/A' : eventData.webinarDetails.description;

  const handleResize = () => {
    setScreenWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  return (
    <>
    {noAccess ? <Error403 /> : hasError ? (<Error404 className="errow-with-nav"/>) : (
    <>
    <BreadCrumbs pages={eventPages} />
    <div className="myk__stu-guide-course-title">
      <span onClick={handleBackClick}>{leftArrowLong}</span>
      <h2>{eventData?.webinarDetails?.title}</h2>
    </div>
    <div className={`${className || ""} myk__stu-courses-wrapper myk__stu-courses_details-wrapper`}>
      <Row>
        <Col md={12} lg={12} xl={8} className="myk__course-details-col">
          {isLoading === false ? (
          <CoursePlay
            className="custom-class"
            imgSrc={eventData.imageDetails.src}
            title={eventData.imageDetails.title}
            defaultImg={defaultImg}
          />
          ):(
          <EventThumbnailLoader />
          )}
          {isLoading === false ? (
          <div className="myk__stu-details-overview myk__stu-event-details-ov">
            <Row>
              <Col xl={8}>
                <div className="myk__stu-course-overview pe-lg-5">
                  <div className="myk__stu-course-about">
                    <div className="d-flex align-items-center justify-content-between">
                      <h2>About the event</h2>
                      {/* {screenWidth < 1199 && (
                      <ShareSocialMedias 
                          className="myk__stu-event-post_share" 
                          heading="Share" 
                          icon={eventData.webinarDetails.backIcon} 
                          shareOptions={eventData.shareOptions} 
                      />
                      )} */}
                    </div>
                    <div dangerouslySetInnerHTML={{ __html: displayDesc }} />
                    {eventData.webinarDetails.description !== '' && eventData.webinarDetails.description.length > maxChars &&
                    <span className="btn btn-transparent mt-3 p-0" onClick={toggleDescription}>
                      {isExpanded ? "Show Less" : "Read More"}
                    </span>
                    }
                    {eventActivityContent && eventActivityContent.length > 0 ?
                    (<EventSessions className="mt-4" eventThumbnail={eventContent?.bce_thumbnail} eventActivities={eventActivityContent} sessionDate={sessionDate} isSessionExpired={isSessionExpired} sessionLocation={eventData?.webinarDetails?.venue} eventStartDateTime={startDateForSession} eventEndDateTime={endDateForSession} />) : ''
                    }
                    {eventData.summary !== '' && 
                    <div className="myk_stu-course-obj">
                      <h2>Summary:</h2>
                      <p dangerouslySetInnerHTML={{__html: eventData?.summary}} />
                    </div>
                    }
                  </div>
                </div>
              </Col>
              <Col xl={4}>
                <div className="myk__stu-instructor-wrapper px-0 px-xxl-4">
                  <h2>Presenter</h2>
                  <div class="myk__stu-presenter-list"> 
                  {eventData.instructorDetails ? eventData.instructorDetails.map((instructor) => (
                  <div className="information-block bg-information-white p-0">
                    <div className="information-wrap mt-1">
                      <div className="information-holder align-items-center gap-2 myk__stu-profile-wrapper">
                        <div
                          data-testid="profileicon"
                          className="circle-wrap circle-wrap-md bg-circle-twilight text-white user-profile"
                        >
                          {instructor.image !== '' ? (
                            <img src={instructor.image} alt="img" />
                          ) : (instructor.name[0])}
                        </div>
                        <div className="information-detail">
                          <h3>{instructor.name}</h3>
                          <p>{instructor.email}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  )) : (
                    <div className="information-block bg-information-white p-0">
                      <div className="information-wrap mt-1">{'N/A'}</div>
                    </div>
                  )}
                  </div> 
                  <div className="myk__stu-course-info">
                    <h2>Event Information</h2>
                    <ul>
                      {eventData.courseInfo.map((info, index) => (
                        info.text !== '' && (
                        <li key={index}>
                          {info.icon} <span>{info.text}</span>
                        </li>
                        )
                      ))}
                    </ul>
                  </div>
                  {eventContent && eventContent.bce_delivered_type === 'live' && (new Date(endDate) > new Date()) &&
                  <Button variant="primary" className="btn-round mt-2 ms-0" onClick={handleJoinEventClick}>Join Event Now</Button>
                  }
                  <br/>
                  {/* {screenWidth >= 1199 && (
                    // <ShareSocialMedias 
                    //     className="myk__stu-event-post_share" 
                    //     heading="Share" 
                    //     icon={eventData.webinarDetails.backIcon} 
                    //     shareOptions={eventData.shareOptions} 
                    // />
                  )} */}
                </div>
              </Col>
            </Row>
          </div>
          ):(
          <EventContentLoader />
          )}
        </Col>
        <Col md={{ span:12, order: 0 }} lg={{ span:12, order: 0 }} xl={{ span:4, order: 0 }} className="myk__course-progress-col">
          {eventAuthToken && uuid && secret && idp && accountId && spuid && timezone &&
            <MyEventCalendar className="mb-4" calendarMode="month" accessToken={encode(eventAuthToken)} uuid={encode(uuid)} secret={encode(secret)} idp={encode(idp)} accountId={encode(accountId)} spuid={encode(spuid)} timeZone={encode(timezone)} language={encode(language)} />}
        </Col>
      </Row>
    </div>
    </>
    )}
    </>
  );
}

export default EventDetails;

